<script setup lang="ts"></script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.1479 2.67923C11.9242 2.29197 11.4213 2 10.9776 2H5.02236C4.57868 2 4.07576 2.29197 3.8521 2.67923L2.34576 5.28866C2.15172 5.62462 2 6.19207 2 6.58116V8.46963C2 8.86789 2.25267 9.2075 2.60447 9.33333V13.0838C2.60447 13.5889 3.01128 14 3.51118 14H12.4888C12.9887 14 13.3955 13.5889 13.3955 13.0838V9.33333C13.7473 9.2075 14 8.86789 14 8.46963V6.58116C14 6.19207 13.8483 5.62462 13.6542 5.28866L12.1479 2.67923Z"
    />
    <path d="M2 6H14" />
    <path d="M2 9L14 9" />
    <path d="M6 11H10" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
